import {
    addToChainAfter,
    addToStartOfChain,
    ApiHandler,
    ApiHandlerDiscreteParameter,
    HandlerWithResult,
    HasOnError,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import {
    createHandlerChainRunnerOptionalParameter,
    Handler,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import {
    AddCartLinesApiParameter,
    AddWishListToCartApiParameter,
    Cart,
    CartResult,
    ClearCartApiParameter,
    RemoveCartLineApiParameter,
    UpdateCartApiParameter,
    UpdateCartLineApiParameter,
} from "@insite/client-framework/Services/CartService";
import { chain, LoadCart, UpdateCartLine } from "@insite/client-framework/Store/Pages/Cart/Handlers/UpdateCartLine";
import { CartLineCollectionModel, CartLineModel, CartModel } from "@insite/client-framework/Types/ApiModels";
import { addCartModifiedToLocalStorage } from "@NA/Utils/Utility";
import { updateCartLineWithResult as updateCartLineApi } from "@insite/client-framework/Services/CartService";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";

interface UpdateCartLineParameter {
    onSuccess?: () => void;
    cartLine: CartLineModel;
    shouldNotReloadPromotions?: boolean;
    shouldNotLoadFullCart?: boolean;
    onError?: () => void;
}

type HandlerType = ApiHandlerDiscreteParameter<UpdateCartLineParameter, UpdateCartLineApiParameter>;

export const PushAddToCartCompleteInLocalStorage: HandlerType = props => {
    addCartModifiedToLocalStorage();
};

export const CustomUpdateCartLine: HandlerType = async props => {
    try {
        await updateCartLineApi(props.apiParameter);
        // await CustomLoadCart(props);
    } catch (error) {
        if (error.status === 400) {
            props.parameter.onError?.();
            return;
        }
        throw error;
    }
};

// export const CustomLoadCart: HandlerType = async props => {
//     props.parameter.shouldNotLoadFullCart
//         ? props.dispatch(
//               loadCurrentCart({
//                   shouldLoadFullCart: false,
//                   getCartLines: true,
//                   getCostCodes: true,
//                   getPromotions: !props.parameter.shouldNotReloadPromotions,
//               }),
//           )
//         : props.dispatch(loadCurrentCart({ getPromotions: !props.parameter.shouldNotReloadPromotions }));
// };

replaceInChain(chain, UpdateCartLine, CustomUpdateCartLine);
// replaceInChain(chain, LoadCart, CustomLoadCart);
addToStartOfChain(chain, PushAddToCartCompleteInLocalStorage); // UpdateCartLine,
